module.exports = __webpack_public_path__ + "static/media/trainers-refresh.21b7544d.png";